module.exports = __webpack_public_path__ + "static/img/q2.a6160c4b.jpg";